module.exports = __webpack_public_path__ + "static/pokoj-nr4-photo02-203c61ca4804b25f65943c2f02642753.jpg";